// extracted by mini-css-extract-plugin
export default {"marginBottomGutter":"marginBottomGutter---pHO_W","greyLabel":"greyLabel---abnOt"};